<ng-template #contenido let-modal>
    <div class="modal-header">
        <h4 class="modal-title"></h4>
        <button type="button" class="btn-close btn-rounded" data-bs-dismiss="modal" aria-label="Close"
            (click)="modal.dismiss()"></button>
    </div>
    <div class="modal-body">
        <app-advancedtable [WsURL]=strWsURLModal (RetornoModal)=RetornoModal($event) [mostrarModal]=true>
        </app-advancedtable>
    </div>
</ng-template>


<div class="card mb-0" #collapse="ngbCollapse" [(ngbCollapse)]="isCollapsed" [horizontal]="true"
    [ngClass]="{'mostrar': !isCollapsed}">

    <div class="row">
        <div class="col-2">
                <button type="button" class="btn" title="Cerrar" (click)="toggleSidebar()"><i
                    class="fa fa-square-caret-right"></i></button>  
        </div>
        <div class="col-10">
            <ng-container *ngIf="operaciones">
                <div style="padding: 0.5rem 0.5rem; float: right;">
                <ng-container *ngFor="let boton of this.operaciones">
                        <button *ngIf="boton.Evento == 'IMPRIMIR' || boton.Evento == 'IMPRIMIR_FIRMAR'"
                            type="button" title="{{boton.Tooltip}}" style="margin-left: 0.5em"
                            id="campo2_{{boton.Evento}}" name="{{boton.Evento}}"
                            (click)="EventoClickMS($event, boton)"
                            class="btn btn-sm btn-sidebar" [ngStyle]="{'background-color': boton.class }">
                            <i class="fas {{boton.icono}} label-icon" style="pointer-events:none ;"></i>
                        </button>
                </ng-container>
            </div>
            </ng-container>
        </div>
    </div>

    <div class="card-body" *ngIf="encabezado">
        <div class="row" *ngFor="let item of encabezado">
            <div class="col-12">
                <div class="mt-1 mb-1">
                    <label>{{item.TITULO}}</label>
                    <input type="text" class="form-control" value="{{item.VALOR}}" readonly>
                </div>
            </div>
        </div>
    </div>

    <div class="card-body p-0">
        <form [formGroup]="myFormGroup" (submit)="ValidarFormulario()" *ngIf="myFormGroup != null">

            <ng-container *ngFor="let form_cards of form_template;">
                <div class="card mb-1">
                    <div class="card-body row">
                        <h4 class="card-title">{{form_cards.descripcion}}</h4>
                        <ng-container *ngFor="let form_elem of form_cards.cards;let indice = index">

                            <ng-container [ngSwitch]="form_elem.type">

                                <ng-container *ngSwitchCase="'textbox_modal'">
                                    <div class="col-12">
                                        <div class="mt-1 mb-1">
                                            <label for="{{form_elem.label}}" (click)="AbrirModal(contenido, form_elem)"
                                                style="text-decoration: underline">
                                                {{form_elem.title}}
                                                <span *ngIf="form_elem.validators.required">(*)</span>
                                            </label>
                                            <input type="text" class="form-control" id="{{form_elem.label}}"
                                                name="{{form_elem.label}}" placeholder="{{form_elem.placeholder}}"
                                                formControlName="{{form_elem.label}}">
                                            <span *ngIf="form_elem.SYS03HLP">{{form_elem.SYS03HLP}}</span>
                                            <div *ngIf="form_elem.validators.required">
                                                <span *ngIf="this.myFormGroup.controls[form_elem.label].invalid"
                                                    class="alert-requerido">
                                                    {{form_elem.validators.msg_validacion}}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>

                                <ng-container *ngSwitchCase="'textbox'">
                                    <div class="col-12">
                                        <div class="mt-1 mb-1">
                                            <label for="{{form_elem.label}}">{{form_elem.title}}
                                                <span *ngIf="form_elem.validators.required">(*)</span>
                                            </label>
                                            <input type="text" class="form-control " id="{{form_elem.label}}"
                                                name="{{form_elem.label}}" placeholder="{{form_elem.placeholder}}"
                                                [readonly]="form_elem.disabled=='S'"
                                                formControlName="{{form_elem.label}}">
                                            <span *ngIf="form_elem.SYS03HLP">{{form_elem.SYS03HLP}}</span>
                                            <div *ngIf="form_elem.validators.required">
                                                <span *ngIf="this.myFormGroup.controls[form_elem.label].invalid"
                                                    class="alert-requerido">
                                                    {{form_elem.validators.msg_validacion}}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>

                                <ng-container *ngSwitchCase="'email'">
                                    <div class="col-12">
                                        <div class="mt-1 mb-1">
                                            <label for="{{form_elem.label}}">{{form_elem.title}}
                                                <span *ngIf="form_elem.validators.required">(*)</span>
                                            </label>

                                            <input type="text" class="form-control " id="{{form_elem.label}}"
                                                name="{{form_elem.label}}" placeholder="{{form_elem.placeholder}}"
                                                [readonly]="form_elem.disabled=='S'"
                                                formControlName="{{form_elem.label}}">
                                            <span *ngIf="form_elem.SYS03HLP">{{form_elem.SYS03HLP}}</span>
                                            <div *ngIf="form_elem.validators.required">
                                                <span *ngIf="this.myFormGroup.controls[form_elem.label].invalid"
                                                    class="alert-requerido">
                                                    {{form_elem.validators.msg_validacion}}
                                                </span>
                                            </div>
                                            <div *ngIf="this.myFormGroup.controls[form_elem.label].errors">
                                                <span *ngIf="this.myFormGroup.controls[form_elem.label].errors.email"
                                                    class="alert-requerido">
                                                    Ingresar email valido
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>


                                <ng-container *ngSwitchCase="'password'">
                                    <div class="col-12">
                                        <div class="mt-1 mb-1">
                                            <label for="{{form_elem.label}}">{{form_elem.title}}
                                                <span *ngIf="form_elem.validators.required">(*)</span>
                                            </label>

                                            <input type="password" class="form-control " id="{{form_elem.label}}"
                                                name="{{form_elem.label}}" placeholder="{{form_elem.placeholder}}"
                                                [readonly]="form_elem.disabled=='S'"
                                                formControlName="{{form_elem.label}}">
                                            <span *ngIf="form_elem.SYS03HLP">{{form_elem.SYS03HLP}}</span>
                                            <div *ngIf="form_elem.validators.required">
                                                <span *ngIf="this.myFormGroup.controls[form_elem.label].invalid"
                                                    class="alert-requerido">
                                                    {{form_elem.validators.msg_validacion}}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>

                                <ng-container *ngSwitchCase="'textbox_date'">
                                    <div class="col-12">
                                        <div class="mt-1 mb-1">
                                            <label for="{{form_elem.label}}">{{form_elem.title}}
                                                <span *ngIf="form_elem.validators.required">(*)</span>
                                            </label>

                                            <input type="date" class="form-control" id="{{form_elem.label}}"
                                                name="{{form_elem.label}}" placeholder="{{form_elem.placeholder}}"
                                                formControlName="{{form_elem.label}}">
                                            <div *ngIf="form_elem.validators.required">
                                                <span *ngIf="this.myFormGroup.controls[form_elem.label].invalid"
                                                    class="alert-requerido">
                                                    {{form_elem.validators.msg_validacion}}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>


                                <ng-container *ngSwitchCase="'number'">
                                    <div class="col-12">
                                        <div class="mt-1 mb-1">
                                            <label>{{form_elem.title}}
                                                <span *ngIf="form_elem.validators.required">(*)</span>
                                            </label>

                                            <input type="text" class="form-control form-control-sm"
                                                id="{{form_elem.label}}" placeholder="{{form_elem.placeholder}}"
                                                formControlName="{{form_elem.label}}" mask="separator.2"
                                                thousandSeparator="," [readonly]="form_elem.disabled=='S'">
                                            <div *ngIf="form_elem.validators.required">
                                                <span
                                                    *ngIf="this.myFormGroup.controls[form_elem.label].invalid || this.myFormGroup.controls[form_elem.label].errors"
                                                    class="alert-requerido">
                                                    {{form_elem.validators.msg_validacion}}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>



                                <ng-container *ngSwitchCase="'select_anterior_disabled'">
                                    <div class="col-12">
                                        <div class="mt-1 mb-1">
                                            <label>{{form_elem.title}}
                                                <span *ngIf="form_elem.validators.required">(*)</span>
                                            </label>

                                            <select class="form-control" id="{{form_elem.label}}"
                                                formControlName="{{form_elem.label}}">
                                                <option *ngFor="let opt of form_elem.options" [value]="opt.value">
                                                    {{opt.text}}
                                                </option>
                                            </select>
                                            <div *ngIf="form_elem.validators.required">
                                                <span *ngIf="this.myFormGroup.controls[form_elem.label].invalid"
                                                    class="alert-requerido">
                                                    {{form_elem.validators.msg_validacion}}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>

                                <ng-container *ngSwitchCase="'select_multiple'">
                                    <div class="col-12">
                                        <div class="mt-1 mb-1">
                                            <label>{{form_elem.title}}
                                                <span *ngIf="form_elem.validators.required">(*)</span>
                                            </label>

                                            <ng-select formControlName="{{form_elem.label}}" id="{{form_elem.label}}"
                                                [(ngModel)]="form_elem.value" [readonly]="form_elem.disabled=='S'"
                                                [items]="form_elem.options" (search)="cargarCombo($event, form_elem)"
                                                bindLabel="text" bindValue="value" multiple="true">
                                            </ng-select>
                                            <div *ngIf="form_elem.SYS03HLP">{{form_elem.SYS03HLP}}</div>
                                            <div *ngIf="form_elem.validators.required">
                                                <span *ngIf="this.myFormGroup.controls[form_elem.label].invalid"
                                                    class="alert-requerido">
                                                    {{form_elem.validators.msg_validacion}}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>


                                <ng-container *ngSwitchCase="'select'">
                                    <div class="col-12">
                                        <div class="mt-1 mb-1">
                                            <label>{{form_elem.title}}
                                                <span *ngIf="form_elem.validators.required">(*)</span>
                                            </label>

                                            <ng-select formControlName="{{form_elem.label}}" id="{{form_elem.label}}"
                                                [(ngModel)]="form_elem.value" (search)="cargarCombo($event, form_elem)"
                                                (change)="CboClick(form_elem)" [readonly]="form_elem.disabled=='S'"
                                                [items]="form_elem.options" bindLabel="text" bindValue="value">
                                            </ng-select>
                                            <div *ngIf="form_elem.SYS03HLP">{{form_elem.SYS03HLP}}</div>
                                            <div *ngIf="form_elem.validators.required">
                                                <span *ngIf="this.myFormGroup.controls[form_elem.label].invalid"
                                                    class="alert-requerido">
                                                    {{form_elem.validators.msg_validacion}}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>

                                <ng-container *ngSwitchCase="'ckeditor'">
                                    <div class="col-12">
                                        <div class="mt-1 mb-1">
                                            <ckeditor [editor]="Editor" [(ngModel)]="form_elem.value"
                                                data={{form_elem.value}} formControlName="{{form_elem.label}}">
                                            </ckeditor>
                                        </div>
                                    </div>
                                </ng-container>


                                <ng-container *ngSwitchCase="'dropzone'">
                                    <div class="col-12">
                                        <div class="mt-1 mb-1">
                                            <label>{{form_elem.title}}
                                                <span *ngIf="form_elem.validators.required">(*)</span>
                                            </label>

                                            <ngx-dropzone (change)="onSelect($event, form_elem)">
                                                <ngx-dropzone-label>Arrastrar y soltar</ngx-dropzone-label>
                                                <ngx-dropzone-preview *ngFor="let f of form_elem.files"
                                                    [removable]="true" (removed)="onRemove(f, form_elem)">
                                                    <ngx-dropzone-label>{{ f.name }} ({{ f.type }})</ngx-dropzone-label>
                                                </ngx-dropzone-preview>
                                            </ngx-dropzone>
                                        </div>
                                    </div>
                                </ng-container>

                                <ng-container *ngSwitchCase="'textarea'">
                                    <div class="col-12">
                                        <div class="mt-1 mb-1">
                                            <label>{{form_elem.title}}
                                                <span *ngIf="form_elem.validators.required">(*)</span>
                                            </label>

                                            <textarea name="{{form_elem.name}}" class="form-control"
                                                id="{{form_elem.label}}" placeholder="{{form_elem.placeholder}}"
                                                formControlName="{{form_elem.label}}">
                                            </textarea>
                                            <div *ngIf="form_elem.validators.required">
                                                <span *ngIf="this.myFormGroup.controls[form_elem.label].invalid"
                                                    class="alert-requerido">
                                                    {{form_elem.validators.msg_validacion}}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>


                                <ng-container *ngSwitchCase="'checkbox'">
                                    <div class="col-12">
                                        <div class="mt-1 mb-1">
                                            <div class="form-check form-switch form-switch-md mb-2">
                                                <input type="checkbox" id="{{form_elem.label}}" class="form-check-input"
                                                    placeholder="{{form_elem.placeholder}}"
                                                    formControlName="{{form_elem.label}}">
                                                <label class="form-check-label " id="{{form_elem.label}}"
                                                    for="{{form_elem.label}}">{{form_elem.title}}</label>
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>



                                <ng-container *ngSwitchCase="'radio'">
                                    <div class="col-12">
                                        <div class="mt-1 mb-1 row">
                                            <label class="col-md-3 col-form-label">{{form_elem.title}}
                                                <span *ngIf="form_elem.validators.required">(*)</span>
                                            </label>
                                            <div class="col-sm-8">
                                                <span class="d-inline-block bloque"
                                                    *ngFor="let option of form_elem.options">
                                                    <input type="radio" name="{{form_elem.name}}"
                                                        value="{{option.value}}" id="{{form_elem.label}}"
                                                        formControlName="{{form_elem.label}}"
                                                        class="form-radio-outline">
                                                    {{option.text}}
                                                </span>
                                                <div *ngIf="form_elem.SYS03HLP">{{form_elem.SYS03HLP}}</div>
                                                <div *ngIf="form_elem.validators.required">
                                                    <span *ngIf="this.myFormGroup.controls[form_elem.label].invalid"
                                                        class="alert-requerido">
                                                        {{form_elem.validators.msg_validacion}}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>

                                <ng-container *ngSwitchCase="'select_url'">
                                    <div class="col-12">
                                        <div class="mt-1 mb-1">
                                            <label *ngIf="form_elem.disabled == 'N';else desactivado"
                                                for="{{form_elem.label}}" (click)="AbrirModal(contenido,form_elem)"
                                                style="text-decoration: underline">
                                                {{form_elem.title}}
                                                <span *ngIf="form_elem.validators.required">(*)</span>
                                            </label>
                                            <ng-template #desactivado>
                                                <label for="{{form_elem.label}}">
                                                    {{form_elem.title}}
                                                    <span *ngIf="form_elem.validators.required">(*)</span>
                                                </label>
                                            </ng-template>
                                            <div>
                                                <input type="text" class="form-control" id="{{form_elem.label}}"
                                                    name="{{form_elem.label}}"
                                                    (change)="SelectURL_Change(form_elem, $event, null)"
                                                    placeholder="{{form_elem.placeholder}}"
                                                    formControlName="{{form_elem.label}}"
                                                    [readonly]="form_elem.disabled=='S'"
                                                    [ngStyle]="{'background-color':form_elem.disabled === 'N'?'':'#eff2f7' }">
                                                <div *ngIf="form_elem.validators.required">
                                                    <span *ngIf="this.myFormGroup.controls[form_elem.label].invalid"
                                                        class="alert-requerido">
                                                        {{form_elem.validators.msg_validacion}}
                                                    </span>
                                                </div>

                                                <div class="col-md-4" *ngIf="form_elem.SYS03CDE">
                                                    <span [textContent]="form_elem.labeldes"></span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>

                                <ng-container *ngSwitchCase="'espacio'">
                                    <div class="col-12">
                                    </div>
                                </ng-container>

                                <ng-container *ngSwitchCase="'titulo'">
                                    <h4 class="card-title mb-2">{{form_elem.title}}</h4>
                                </ng-container>

                                <ng-container *ngSwitchCase="'select_url_anterior'">
                                    <div class="col-12">
                                        <div class="mt-1 mb-1">
                                            <label>{{form_elem.title}}
                                                <span *ngIf="form_elem.validators.required">(*)</span>
                                            </label>

                                            <app-cbo-select>
                                                <ng-template #selectedTemplate let-shark>
                                                    {{ shark?.name || "Shark" }}
                                                </ng-template>

                                                <ng-template #optionTemplate let-shark let-id="index">
                                                    <a class="dropdown-item"
                                                        [style.color]="id % 2 == 0 ? 'black' : 'blue'">
                                                    </a>
                                                </ng-template>
                                            </app-cbo-select>
                                        </div>
                                    </div>
                                </ng-container>

                                <ng-container *ngSwitchCase="'span'">
                                    <div class="col-12">
                                        <div class="mt-1 mb-1">
                                            <label>{{form_elem.title}}</label>

                                            <input type="text" class="form-control" id="{{form_elem.label}}"
                                                name="{{form_elem.label}}" placeholder="{{form_elem.placeholder}}"
                                                formControlName="{{form_elem.label}}" disabled>
                                        </div>
                                    </div>
                                </ng-container>

                                <ng-container *ngSwitchCase="'hidden'">
                                    <input type="hidden" class="form-control" id="hide_{{form_elem.label}}"
                                        name="{{form_elem.label}}" placeholder="{{form_elem.placeholder}}"
                                        formControlName="{{form_elem.label}}">
                                </ng-container>

                                <!--  <ng-container *ngSwitchCase="'fotografia'">
                                    <div class="col-12">
                                        <div class="mt-1 mb-1">
                                            <div style="text-align: center;" class="position-relative mb-3">
                                                <img [src]="strFOTO" />
                                            </div>
                                        </div>
                                    </div>
                                </ng-container> -->
                            </ng-container>
                        </ng-container>
                    </div>
                </div>
            </ng-container>
        </form>

        <div class="row" *ngIf="this.ToolbarMS">
            <div class="col-12 text-center">
                <ng-container *ngFor="let boton of this.ToolbarMS">
                    <div class="d-inline-block bloque" *ngIf="boton.Evento == 'UPDATE_GENERICO'">
                        <button type="button" title="{{boton.Tooltip}}" Style="margin-left: 10px"
                            id="campo2_{{boton.Evento}}" name="{{boton.Evento}}"
                            (click)="EventoClickMS($event, boton)"
                            class="btn btn-label waves-light btn-sm" [ngStyle]="{'background-color': boton.class }">
                            <i class="fas {{boton.icono}} label-icon" style="pointer-events:none ;"></i>
                            {{boton.boton}}
                        </button>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
    <label for="">{{this.SYS02CON}}</label>
</div>

<div [ngClass]="isCollapsed ? 'mostrar': 'ocultar'" style="height: 100%;">
    <div class="card" style="height: 100%;">
        <div class="card-body" style="padding: 0;">
            <button type="button" title="Abrir" class="btn" (click)="toggleSidebar()"><i
                    class="fa fa-square-caret-left"></i></button>
        </div>
    </div>
</div>

<app-scroll-to-top>
</app-scroll-to-top>